import React from "react";
import { X } from "lucide-react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const FloatingProgressToast = ({
  icon,
  title,
  subtitle,
  action = null,
  onDismiss,
  dismissLabel = "Dismiss",
  children,
  className = "",
  headerClassName = "",
  bodyClassName = "",
}) => {
  return (
    <div
      className={cn(
        "max-w-[380px] w-[min(380px,calc(100vw-40px))] rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 shadow-[0_12px_40px_-12px_rgba(15,23,42,0.2)] overflow-hidden",
        className,
      )}
    >
      <div
        className={cn(
          "flex items-start justify-between gap-2 px-4 pt-4 pb-3 border-b border-gray-100 dark:border-gray-800",
          headerClassName,
        )}
      >
        <div className="flex gap-2.5 min-w-0">
          {icon}
          <div className="flex items-center gap-2 min-w-0">
            <div className="min-w-0">
              <h3 className="text-gray-900 dark:text-gray-100 font-semibold text-sm leading-tight truncate">
                {title}
              </h3>
              {subtitle ? (
                <p className="text-gray-500 dark:text-gray-400 text-[11px] mt-0.5 leading-snug">
                  {subtitle}
                </p>
              ) : null}
            </div>

            {action}
          </div>
        </div>

        {onDismiss ? (
          <button
            type="button"
            onClick={onDismiss}
            className="shrink-0 p-1 rounded-md text-gray-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            aria-label={dismissLabel}
          >
            <X size={16} strokeWidth={2} />
          </button>
        ) : null}
      </div>

      {children ? <div className={bodyClassName}>{children}</div> : null}
    </div>
  );
};

export default FloatingProgressToast;
